module.exports = __webpack_public_path__ + "static/crowdfunding-fulfillment-featured-0e9089637a3e3f3c71f8613b3f7c1566.png";